// 基础组件
import { SdIcon            } from './components/icon'
import { SdLink            } from './components/link'
import { SdImage           } from './components/image'
import { SdStatus          } from './components/status'
import { SdDateButtonGroup } from './components/date-button-group'

// 数据展示
import { SdStatistic       } from './components/statistic'
import { SdCard            } from './components/card'
import { SdTitleBar        } from './components/title-bar'
import { SdCalendar        } from './components/calendar'
import { SdTypeList        } from './components/type-list'
import { SdTypeTree        } from './components/type-tree'
import { SdPage            } from './components/page'

// 导航
import { SdTabs            } from './components/tabs'

// 反馈组件
import { SdDialog          } from './components/dialog'
import { SdDrawer          } from './components/drawer'

import type { Plugin } from 'vue'
export default [
    // 基础组件
    SdIcon,
    SdLink,
    SdImage,
    SdStatus,
    SdDateButtonGroup,  

    // 数据展示
    SdStatistic,
    SdCard,
    SdTitleBar,
    SdCalendar,
    SdTypeList,
    SdTypeTree,
    SdPage,

    // 导航
    SdTabs,

    // 反馈组件
    SdDialog,
    SdDrawer,
] as Plugin[]
